import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledAllDiscountProducts = styled('div')`
  background-color: ${({ theme }) => theme.whiteSmoke};

  .popular-categories {
    padding-bottom: 75px;
    padding-top: 84px;
  }

  .products-filters-container {
    display: flex;
    flex-direction: row;
    column-gap: 50px;

    .ant-form {
      padding-right: 0;
    }

    .ant-select-selector {
      background-color: ${({ theme }) => theme.lightGrey} !important;
    }

    .ant-spin-nested-loading {
      width: 100%;
      justify-content: center;
    }

    .products-wrapper {
      .products {
        flex-wrap: wrap;
        padding-top: 40px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 20px;
        justify-content: center;
        justify-items: center;
      }

      .pagination {
        display: flex;
        justify-content: center;
        padding: 77px 0 83px 0;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          font-family: ${({ theme }) => theme.fontText} !important;
        }
      }

      .category_name {
        display: none;
      }
    }
    .ant-select-selector {
      border: 1px solid ${({ theme }) => theme.borderBottom};
    }

    .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.colorText} !important;
      font-size: 16px;
      line-height: 28px;
    }

    .form-container {
      margin-top: 40px;
    }
  }

  .product-name-and-qmarks-container {
    .product-name {
      margin-top: 0 !important;
    }
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  .ant-pagination-prev {
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 24px;
  }

  .discount-items {
    display: none;
  }

  .popular-categories {
    padding-bottom: 50px;
    padding-top: 100px;

    h1 {
      margin-bottom: 19px;
    }
  }

  .banners {
    padding-bottom: 39px;
    background-color: ${({ theme }) => theme.white};

    .slick-slider {
      margin-bottom: 0;

      .banner-image-wrapper {
        padding: 0;
      }

      .slick-dots-bottom {
        bottom: -32px;
      }
    }

    .banner-wrapper:first-child {
      .slick-dots-bottom {
        bottom: -20px;
      }
    }

    .banner-wrapper {
      padding: 21px 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .products-filters-container {
      .form-container {
        display: none;
      }

      .form-container {
        padding: 0 20px 0 20px;
      }
      .products-wrapper {
        .products {
          justify-content: center;
          padding: 0;
        }

        .category_name {
          text-align: center;
          display: block;
          font-size: 1.125rem;
          font-weight: 600;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .popular-categories {
      padding-bottom: 0;
      padding-top: 0;
    }

    .mobile-product-category {
      padding: 20px 0 44px 0;

      .title {
        padding: 0 20px;

        h1 {
          margin-top: 0;
        }
      }
    }


    .products-container {
      background-color: ${({ theme }) => theme.inputGrey};
    }

    .ant-pagination-prev {
      margin-inline-end: 6px !important;
    }

    .ant-pagination-next {
      margin-inline-start: 6px !important;
    }

    .discount-items {
      display: block;
      padding-top: 25px;
      background-color: ${({ theme }) => theme.brightGrey};

      .slick-dots-bottom {
        bottom: 0;
      }
    }

    .banners {
      padding-bottom: 0;
      background-color: ${({ theme }) => theme.brightGrey};

      .desktop-banner {
        display: block;
      }
      .slick-dots {
        display: none !important;
      }

      .banner-wrapper {
        padding-top: 0;
      }

      .desktop-banner:first-child {
        padding-bottom: 21px;
      }
    }

    .products-filters-container {
      .products-wrapper {
        .products {
          gap: 15px;
          grid-template-columns: 1fr;
        }

        .category_name {
          text-align: start;
        }
      }

      .pagination {
        padding: 15px 0 33px 0 !important;
      }
    }

    .ant-pagination-prev {
      margin-right: 6px;
    }

    .ant-pagination-next {
      margin-left: 6px;
    }
  }
`;
